import { Component, Input } from '@angular/core'
import { DatePipe } from '@angular/common'
import { TransactionDetails } from '../../models'
import { StatusBadgeComponent } from '../status-badge/status-badge.component'
import { NegativeCurrencyPipe } from '../../pipes/negative-currency.pipe'
import { getOriginTypeLabel } from '../../utils/origin-type-labels'

@Component({
    selector: 'ach-transaction-overview',
    standalone: true,
    imports: [DatePipe, StatusBadgeComponent, NegativeCurrencyPipe],
    templateUrl: './transaction-overview.component.html',
    styleUrl: './transaction-overview.component.scss',
})
export class TransactionOverviewComponent {
    @Input({ required: true }) details!: TransactionDetails

    get originTypeLabel(): string {
        return getOriginTypeLabel(this.details.originType)
    }

    get showRefundedAmount(): boolean {
        const type = this.details.transactionType?.toLowerCase()
        return type !== 'refund' && type !== 'return'
    }

    get refundedAmount(): number | null {
        const refunds = this.details.relatedTransactions?.filter(
            r => r.relationship?.toLowerCase() === 'refund'
        ) ?? []
        if (refunds.length === 0) return null
        return -refunds.reduce((sum, r) => sum + r.amount, 0)
    }
}
